import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Global } from '../../shared/global';
import { EMPTY, Observable, from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IKfzAntrag } from '../models/kfzantrag';
import { IRsAntrag } from '../models/rsantrag';
import { IHvAntrag } from '../models/hvantrag';
import { Router } from '@angular/router';
import { MaintainanceService } from './maintainance.service';
import { IFile } from '../models/file';
import { IAntragResult } from '../models/antragresult';

@Injectable({
  providedIn: 'root'
})
export class AntragService {

  constructor(private http: HttpClient, private router: Router, private maintainanceService: MaintainanceService) { }

  createKfzAntrag(model: IKfzAntrag, query: string, solution: Promise<string>): Observable<IAntragResult> {
    const body = JSON.stringify(model);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers };
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['/maintenance']);
          return EMPTY;
        } else {
          return from(solution).pipe(
            switchMap(solution => this.http.post<IAntragResult>(Global.BASE_ANTRAG_ENDPOINT +
              `createkfzantrag?captchaResponse=${encodeURIComponent(solution)}` + (query ? `&q=${query}` : ''), body, options)));
        }
      }));
  }

  submitKfzAntrag(model: IKfzAntrag, files: IFile[], query: string, solution: Promise<string>): Observable<IFile[]> {
    const formData = new FormData();
    formData.append('value', JSON.stringify(model));
    formData.append('files', JSON.stringify(files));
    files.forEach((file) => {
      formData.append('filesdata', (file.File ?? new File([''], file.Name)));
    });
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['/maintenance']);
          return EMPTY;
        } else {
          return from(solution).pipe(
            switchMap(solution => this.http.post<IFile[]>(Global.BASE_ANTRAG_ENDPOINT +
              `submitKfzAntrag?captchaResponse=${encodeURIComponent(solution)}` + (query ? `&q=${query}` : ''), formData)));
        }
      }));
  }

  createRsAntrag(model: IRsAntrag, query: string, solution: Promise<string>): Observable<any> {
    const body = JSON.stringify(model);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers, responseType: 'blob' as 'blob' };
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['/maintenance']);
          return EMPTY;
        } else {
          return from(solution).pipe(
            switchMap(solution => this.http.post(Global.BASE_ANTRAG_ENDPOINT +
              `creatersantrag?captchaResponse=${encodeURIComponent(solution)}` + (query ? `&q=${query}` : ''), body, options).pipe(map(data => {
                return new Blob([data], { type: 'application/pdf', });
              }))));
        }
      }));
  }

  createHvAntrag(model: IHvAntrag, query: string, solution: Promise<string>): Observable<any> {
    const body = JSON.stringify(model);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers, responseType: 'blob' as 'blob' };
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['/maintenance']);
          return EMPTY;
        } else {
          return from(solution).pipe(
            switchMap(solution => this.http.post(Global.BASE_ANTRAG_ENDPOINT +
              `createhvantrag?captchaResponse=${encodeURIComponent(solution)}` + (query ? `&q=${query}` : ''), body, options).pipe(map(data => {
                return new Blob([data], { type: 'application/pdf', });
              }))));
        }
      }));
  }
}
